var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-container"},[_c('el-tooltip',{staticClass:"my-tooltip",attrs:{"placement":"top-start","disabled":_vm.showTooltip,"content":_vm.text}},[_c('p',{ref:"tooltipBox",staticClass:"text-box"},[_c('span',{ref:"tooltipItem"},[_vm._v(_vm._s(_vm.text))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }